import axios from 'axios';
import * as actionTypes from './Actiontypes';
import { toast } from 'react-toastify';


const BASE_URL = "https://api.happiclips.com/api"

export const userlogin = (email, password) => {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.LOGIN_INIT
        })
        try {
            const res = await axios.post(`${BASE_URL}/user/login`, { email_or_phone: email, password });

            if (res.data.success === false) {
                dispatch({
                    type: actionTypes.LOGIN_FAIL,
                    payload: 'error'
                })
                toast.error("Invalid email or password");

            }
            else {
                localStorage.setItem('authToken', res?.data?.data?.token)

                dispatch({
                    type: actionTypes.LOGIN_SUCCESS,
                    payload: res.data
                });
                localStorage.setItem("user_id", '1')
                toast.success("Login successful!");
            }
        }
        catch (error) {
            dispatch({
                type: actionTypes.LOGIN_FAIL,
                payload: 'error'
            })
            toast.error(error.response?.data?.message || "Invalid email or password");
        }
    }
}
export const usersignup = (payload) => {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.SIGNUP_INIT
        })
        // const authToken = localStorage.getItem('authToken');
        try {
            const res = await axios.post(`${BASE_URL}/user/register`, payload);
            toast.success(res?.data?.message || 'User registered successfully!');
            dispatch({
                type: actionTypes.SIGNUP_SUCCESS,
                payload: res.data
            })
        }
        catch (error) {
            dispatch({
                type: actionTypes.SIGNUP_FAIL,
                payload: 'error'
            })

            throw error;
        }
    }
}

export const userlogout = () => {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.LOGIN_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');

            if (authToken) {
                await axios.get(`${BASE_URL}/logout`, {
                    headers: {
                        Authorization: `Bearer ${authToken}`
                    }
                });
            }
            localStorage.removeItem('authToken');
            localStorage.clear();
            dispatch({
                type: actionTypes.LOGOUT_SUCCESS,

            })
            window.location.replace(`${window.localStorage.origin}`);

        }
        catch (error) {
            dispatch({
                type: actionTypes.LOGOUT_FAIL,
                payload: 'Unknown error occurred. Please try again later!'
            });
            toast.error("Invalid emil_or_phone or password!!")
            localStorage.clear();
            window.location.replace(`${window.location.origin}`);
        }
    }
}

export const getProfile = () => {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.GET_PROFILE_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');

            if (authToken) {
                const response = await axios.get(`${BASE_URL}/get-profile`, {
                    headers: {
                        Authorization: `Bearer ${authToken}`
                    }
                });
                // Dispatch success with the profile data
                dispatch({
                    type: actionTypes.GET_PROFILE_SUCCESS,
                    payload: response.data.data, // Assuming the profile is in response.data
                });
                return response.data.data;
            } else {
                dispatch({
                    type: actionTypes.GET_PROFILE_FAIL,
                    payload: 'No authentication token found.',
                });
            }
        } catch (error) {
            dispatch({
                type: actionTypes.GET_PROFILE_FAIL,
                payload: error.response?.data?.message || 'Unknown error occurred. Please try again later!',
            });
            toast.error("User not found or session expired.");
            localStorage.clear();
            window.location.replace(`${window.location.origin}`);
        }
    }
}

export const updateProfile = (updatedData) => {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.UPDATE_PROFILE_INIT,
        });

        try {
            const authToken = localStorage.getItem('authToken');
            if (authToken) {
                const response = await axios.post(
                    `${BASE_URL}/profile/update`,
                    updatedData,
                    {
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );
                dispatch({
                    type: actionTypes.UPDATE_PROFILE_SUCCESS,
                    payload: response.data.user,
                });

                toast.success('Profile updated successfully!');
                return response.data.data;
            } else {
                dispatch({
                    type: actionTypes.UPDATE_PROFILE_FAIL,
                    payload: 'No authentication token found.',
                });
                toast.error('Please log in to update your profile.');
            }
        } catch (error) {
            dispatch({
                type: actionTypes.UPDATE_PROFILE_FAIL,
                payload: error.response?.data?.message || 'Unknown error occurred. Please try again later!',
            });
            toast.error(error.response?.data?.message || 'Failed to update profile.');
        }
    };
};

export const forgotPassword = ({ email }) => {
    return async (dispatch) => {
        dispatch({ type: actionTypes.FORGOT_PASSWORD_INIT });

        try {
            const res = await axios.post(`${BASE_URL}/password/forgot`, { email });

            if (res.data.success === false) {
                dispatch({
                    type: actionTypes.FORGOT_PASSWORD_FAIL,
                    payload: 'error'
                });
                throw new Error("Failed to send reset link");
            } else {
                dispatch({
                    type: actionTypes.FORGOT_PASSWORD_SUCCESS,
                    payload: res.data
                });
                return res.data; // <-- ✅ Return success data
            }
        } catch (error) {
            dispatch({
                type: actionTypes.FORGOT_PASSWORD_FAIL,
                payload: 'error'
            });
            throw error; // <-- ✅ Throw error so `.catch()` in the component works
        }
    }
}


export const resetPassword = ({ token, email, password, password_confirmation }) => {
    return async (dispatch) => {
        dispatch({
            type: actionTypes.RESET_PASSWORD_INIT
        });

        try {
            const res = await axios.post(`${BASE_URL}/password/reset`, {
                token,
                email,
                password,
                password_confirmation
            });

            if (res.data.success === false) {
                dispatch({
                    type: actionTypes.RESET_PASSWORD_FAIL,
                    payload: 'error'
                });
                toast.error("Failed to reset password. Please try again.");
            } else {
                dispatch({
                    type: actionTypes.RESET_PASSWORD_SUCCESS,
                    payload: res.data
                });
                toast.success("Password has been reset successfully!");
            }
        } catch (error) {
            dispatch({
                type: actionTypes.RESET_PASSWORD_FAIL,
                payload: 'error'
            });
            toast.error(error.response?.data?.message || "Something went wrong. Please try again.");
        }
    }
}
